import { addDimensionToDatalayer, putCusDimInDatalayer } from "../../@helpers/js/datalayer.js";
import { triggerNotify, subscribeNotify, subscribeNamedNotify, registerTrigger, resetTriggers, subscribeUniqueNamedNotify, unsubscribeNamedNotify, unsubscribeNotify, unsubscribeUniqueNamedNotify } from "../../@helpers/js/observer.js";

class CollectiveSearch {
  constructor(element, {
    searchUrl,
    saveUrl,
    defaultColl,
    changeLocation = false,
    backendError = "Helaas geeft de server een foutmelding probeer het later nog eens.",
    intermediairKey,
  } = {}) {
    this._element = element;
    this._options = {
      searchUrl,
      saveUrl,
      changeLocation,
      defaultColl,
      backendError,
      intermediairKey,
    };
    this._collData = null;
    this.init();
  }

  init() {
    this._pres = this._element.querySelector("[data-collective-presentation]");
    this._collSearch = this._element.querySelector("[data-collective-search]");
    registerTrigger("collectivity_result");
    registerTrigger("collectivity_removed");
    registerTrigger("changeInsurance_reinit");
    registerTrigger("shoppingcart_recalculate");
    if (this._collSearch) {
      this._overlayTrigger = this._element.closest("[data-overlay-source]")?.dataset.overlaySource;
      this._name = this._pres?.querySelector("[data-collective-name]") ?? {};
      this._number = this._pres?.querySelector("[data-collective-number]") ?? {};
      this._intermediairInfo = this._pres?.querySelector("[data-intermediair-info]") ?? {};
      this._intermediair = this._pres?.querySelector("[data-intermediair-name]") ?? {};
      this._logo = this._pres?.querySelector("[data-collective-logo]") ?? {};
      this._shortinfo = this._pres?.querySelector("[data-collective-shortinfo]") ?? {};
      this._main = this._pres?.querySelector("[data-percent-main]") ?? {};
      this._main_wrapper = this._pres?.querySelector("[data-discount-main]") ?? {};
      this._additional = this._pres?.querySelector("[data-percent-additional]") ?? {};
      this._additional_wrapper = this._pres?.querySelector("[data-discount-additional]") ?? {};
      this._dental = this._pres?.querySelector("[data-percent-dental]") ?? {};
      this._dental_wrapper = this._pres?.querySelector("[data-discount-dental]") ?? {};
      this._description = this._element.querySelector("[data-description]");
      this._error = this._element.querySelector("[data-error]");
      this._saveBtn = this._element.querySelector( "button[data-save-collectivity]" );
      this._collectiveIntermediair = this._element.querySelector( "[data-collective-intermediair]" );
      this._municipalityNotification = this._element.querySelector( "[data-municipality-notification]" );
      this._municipalityNotificationText = this._element.querySelector( "[data-municipality-notification-text]" );
      if (this._collectiveIntermediair) {
        this._hasCollectiveIntermediary = true;
        this._collectiveIntermediairSelect = this._element.querySelector( "[data-collective-intermediair-select]" );
        this._collectiveIntermediairSelectError = this._element.querySelector( "[data-collective-intermediair] [data-error]" );
      }
      this._fitzmeLabel = this._element.querySelector("[data-fitzme-label]");

      const clearErrors = () => {
        if (this._collSearch.classList.contains("-has-error")) {
          this._collSearch.classList.remove("-has-error");
          return true;
        }
        return false;
      };

      this._searchBtn = this._element.querySelector( "button[data-submit-search]" );
      this._searchInput = this._element.querySelector( "input[data-search-field]" );

      const collectiveRemove = async () => {
        this._description?.classList?.remove("t-hidden");
        this._pres?.classList?.add("t-hidden");
        clearErrors();
        this._collSearch.classList.remove("parsley-success");
        if (this._searchInput) {
          this._searchInput.value = "";
          if (this._options.saveUrl && this._options.defaultColl) {
            let sessionForm = [
              { key: this._searchInput.name, value: this._options.defaultColl },
              { key: this._options.intermediairKey, value: "" },
            ];
            await this._callbackend(sessionForm);
            resetTriggers([
              "maininsurance_selected",
              "Additional_includes_Dental",
            ]);
            triggerNotify("collectivity_removed").then(() => {
              triggerNotify("changeInsurance_reinit");
              triggerNotify("shoppingcart_recalculate");
            });
            this._saveBtn.classList.remove("loading");
            this._saveBtn.disabled = false;
          }
        }
      }

      subscribeNotify("collectivity_remove", collectiveRemove);
      
      const overlayClosing = () => {
        if (clearErrors()) {
          this._description?.classList?.remove("t-hidden");
          this._pres?.classList?.add("t-hidden");
          this._searchInput.value = "";
        }
        unsubscribeNotifications(this._overlayTrigger);
      }
      
      subscribeNamedNotify("justOverlay_overlayClosing", { name: this._overlayTrigger, fn: overlayClosing });
      
      const selectcomplete = async (suggestion) => {
        clearErrors();
        if (suggestion || this._validator.validate()) {
          this._findCollectivity(this._searchInput.value);
        }
      }
      
      subscribeNotify("searchsuggestions-selectcomplete", selectcomplete);

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          this._collSearch.classList.remove("loading");
          this._searchBtn.disabled = false;
          this._searchInput.disabled = false;
        }
      });
      
      function unsubscribeNotifications(overlayTrigger) {
        if (overlayTrigger && overlayTrigger.toLowerCase() === "pakketkiezer") {
          unsubscribeNotify("collectivity_remove", collectiveRemove);
          unsubscribeNotify("searchsuggestions-selectcomplete", selectcomplete);
          unsubscribeNamedNotify("justOverlay_overlayClosing", { name: overlayTrigger, fn: overlayClosing });
          unsubscribeUniqueNamedNotify("pakketkiezer_collectivity_next", { name: overlayTrigger, fn: () => true });
          unsubscribeUniqueNamedNotify("choosingaid_collectivechoice_no_selected", { name: overlayTrigger, fn: () => true });
          unsubscribeUniqueNamedNotify("choosingaid_collectivechoice_validate", { name: overlayTrigger, fn: () => true });
          unsubscribeUniqueNamedNotify("steploader_getstep_release", { name: overlayTrigger, fn: () => true });
        }
      }

      this._isPakketKiezer = this._overlayTrigger?.toLowerCase() === "pakketkiezer";

      if (this._isPakketKiezer) {
        subscribeUniqueNamedNotify("pakketkiezer_collectivity_next", {
          name: this._overlayTrigger, fn: () => {
            if (this._collectiveIntermediair.classList.contains("t-hidden")) {
              return true;
            }
            if (this._hasCollectiveIntermediary && this._collectiveIntermediairSelect && !this._collectiveIntermediair.classList.contains("t-hidden")) {
              if (this._collectiveIntermediairSelect.value) {
                this._collectiveIntermediair.querySelector("[data-input]").classList.remove("-has-error");
                return true;
              } else {
                this._collectiveIntermediair.querySelector("[data-input]").classList.add("-has-error");
                if (this._collectiveIntermediairSelectError) {
                  this._collectiveIntermediairSelectError.innerHTML = this._collectiveIntermediairSelect.dataset.requiredMessage || "Tussenpersoon is verplicht!";
                }
                return false;
              }
            }
          }
        });
        
        subscribeUniqueNamedNotify("choosingaid_collectivechoice_no_selected", {
          fn: () => {
            this._description?.classList?.remove("t-hidden");
            this._pres?.classList?.add("t-hidden");
            clearErrors();
            this._collSearch.classList.remove("parsley-success");
            if (this._searchInput) {
              this._searchInput.value = "";
            }
          }, name: this._overlayTrigger
        });
        
        subscribeUniqueNamedNotify("choosingaid_collectivechoice_validate", {
          fn: async ({showError}) => {
            if (this._validator && showError) {
              return this._validator.validate();
            }
            return false;
          }, name: this._overlayTrigger
        });
        
        subscribeUniqueNamedNotify("steploader_getstep_release", { name: this._overlayTrigger, fn: () => unsubscribeNotifications(this._overlayTrigger) });
      }

      function callCloseOverlay() {
        let overlayClose = document.querySelector("[data-overlay-close]");
        if (overlayClose) {
          overlayClose.dispatchEvent(new Event("click"));
        }
      }

      if (this._saveBtn) {
        this._saveBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          if (this._collData) {
            if (this._options.saveUrl) {
              let closeOverlay = true;
              let sessionForm = [{ key: this._searchInput.name, value: this._number.value }];
              if ( this._hasCollectiveIntermediary && this._collectiveIntermediairSelect && !this._collectiveIntermediair.classList.contains("t-hidden") ) {
                if (this._collectiveIntermediairSelect.value) {
                  sessionForm.push({
                    key: this._collectiveIntermediairSelect.name,
                    value: this._collectiveIntermediairSelect.value,
                  });
                } else {
                  closeOverlay = false;
                  this._collectiveIntermediair.querySelector("[data-input]").classList.add("-has-error");
                  if (this._collectiveIntermediairSelectError) {
                    this._collectiveIntermediairSelectError.innerHTML = this._collectiveIntermediairSelect.dataset.requiredMessage || "Tussenpersoon is verplicht!";
                  }
                }
              }
              if (closeOverlay) {
                await this._callbackend(sessionForm);
                resetTriggers([
                  "maininsurance_selected",
                  "Additional_includes_Dental",
                ]);
                triggerNotify("collectivity_result", this._collData).then( () => {
                    triggerNotify("changeInsurance_reinit");
                    triggerNotify("shoppingcart_recalculate");
                    putCusDimInDatalayer(26, this._collData.collectivityNumber);
                    addDimensionToDatalayer('collectiviteit', this._collData.collectivityNumber);
                  }
                );
                callCloseOverlay();
              }
            }
            this._saveBtn.classList.remove("loading");
            if (this._hasCollectiveIntermediary) {
              let inputcontainer = this._collectiveIntermediair.querySelector( "[data-input]" );
              inputcontainer && inputcontainer.classList.remove("parsley-success");
            }
            this._saveBtn.disabled = false;
          }
        });
      }

      if (this._collectiveIntermediairSelect) {
        this._collectiveIntermediairSelect.addEventListener("change", () => {
          let inputcontainer = this._collectiveIntermediair.querySelector( "[data-input]" );
          if (inputcontainer) {
            inputcontainer.classList.remove("-has-error");
            inputcontainer.classList.add("parsley-success");
          }
          this._collData["intermediairName"] = this._collectiveIntermediairSelect.options[this._collectiveIntermediairSelect.selectedIndex].innerText;
          this._collData["IntermediairNumber"] = this._collectiveIntermediairSelect.value;
        });
      }

      const cancelButton = this._element.querySelector( "[data-cancel-collectivity]" );
      if (cancelButton) {
        cancelButton.addEventListener("click", (e) => {
          e.preventDefault();
          callCloseOverlay();
        });
      }
    }
  }

  async _findCollectivity(collNr) {
    if (!collNr || !collNr.trim()) {
      return;
    }
    if (collNr.length > 9) {
      collNr = collNr.slice(-4);
    }
    collNr = collNr.padStart(9, "0");
    if (this._options.changeLocation) {
      this._collSearch.classList.add("loading");
      this._searchBtn.disabled = true;
      this._searchInput.disabled = true;
      let collUrl = `${location.pathname}?${collNr}`;
      location.href = collUrl;
      return;
    }
    if (!this._options.searchUrl) {
      return;
    }
    let apiUrl = `${this._options.searchUrl}?collectivityNumber=${collNr}`;
    try {
      this._collSearch.classList.add("loading");
      this._searchBtn.disabled = true;
      this._searchInput.disabled = true;
      this._pres?.classList?.add("t-hidden");
      let f = fetch(apiUrl, {
        method: "POST",
        body: "{}",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      let response = await f;
      let result = await response.json();

      if (result && result.isSucces) {
        if (result.data) {
          this._collData = result.data;
          this._collData.collectivityNumber = collNr;
          setTimeout(async () => await addDimensionToDatalayer('collectiviteit', this._collData.collectivityNumber), 0);
          if (this._name) {
            this._name.innerHTML = result.data["collectivityName"];
            const imageUrl = result.data["companyLogoImageUrl"];
            if (this._logo) {
              if (imageUrl) {
                this._logo.setAttribute("src", imageUrl);
                this._logo.setAttribute( "alt", `logo van ${result.data["collectivityName"]}`
                );
                this._logo.classList.remove("t-hidden");
              } else {
                this._logo.classList.add("t-hidden");
              }
            }
          }
          if (this._intermediair) {
            if (result.data["intermediairName"]) {
              setTimeout(async () => await addDimensionToDatalayer('intermediair', this._collData.intermediairNumber), 0);
              this._intermediair.innerHTML = result.data["intermediairName"];
              this._intermediairInfo.classList.remove("t-hidden");
            } else {
              this._intermediairInfo.classList.add("t-hidden");
            }
          }
          if (this._municipalityNotification) {
            if (result.data["isMunicipality"]) {
              this._pres?.classList?.add("c-collective__municipality");
              this._municipalityNotificationText.innerHTML =
                result.data["municipalityNotification"];
              this._municipalityNotification.classList.remove("t-hidden");
            } else {
              this._pres?.classList?.remove("c-collective__municipality");
              this._municipalityNotification.classList.add("t-hidden");
            }
          }

          if ( this._collectiveIntermediair && this._collectiveIntermediairSelect
          ) {
            if ( result.data["intermediairNumberNameCollection"] && result.data["intermediairNumberNameCollection"].length > 0
            ) {
              const tussenpersoonArr =
                result.data["intermediairNumberNameCollection"];
              this._collectiveIntermediairSelect.selectedIndex = 0;
              const intermediairOptions = this._collectiveIntermediairSelect.querySelectorAll( "option" );
              intermediairOptions.forEach((option) => {
                if (option !== this._collectiveIntermediairSelect.options[0]) {
                  option.remove();
                }
              });
              tussenpersoonArr.forEach((tussenpersoon) => {
                const option = document.createElement("option");
                option.value = tussenpersoon.number;
                option.innerText = tussenpersoon.name;
                this._collectiveIntermediairSelect.appendChild(option);
              });

              this._collectiveIntermediair.classList.remove("t-hidden");
            } else {
              this._collectiveIntermediair.classList.add("t-hidden");
            }
          }

          if (this._number) {
            this._number.value = collNr;
          }
          if (this._shortinfo) {
            const fitzme = result.data["showFitzme"];
            if (this._fitzmeLabel) {
              fitzme
                ? this._fitzmeLabel.classList.remove("t-hidden")
                : this._fitzmeLabel.classList.add("t-hidden");
            }
            const numberFormatter = Intl.NumberFormat( document.firstElementChild?.lang || navigator.language || "nl-NL" );
            const mainpercentage = numberFormatter.format( result.data["discountPercentageMainInsurance"] );
            if (this._main) {
              this._main.innerHTML = mainpercentage;
              if (this._main_wrapper) {
                result.data["discountPercentageMainInsurance"]
                  ? this._main_wrapper.classList.remove("t-hidden")
                  : this._main_wrapper.classList.add("t-hidden");
              }
            }
            const addpercentage = numberFormatter.format( result.data["discountPercentageAdditionalInsurance"] );
            if (this._additional) {
              this._additional.innerHTML = addpercentage;
              if (this._additional_wrapper) {
                result.data["discountPercentageAdditionalInsurance"]
                  ? this._additional_wrapper.classList.remove("t-hidden")
                  : this._additional_wrapper.classList.add("t-hidden");
              }
            }
            const dentpercentage = numberFormatter.format( result.data["discountPercentageDentalInsurance"] );
            if (this._dental) {
              this._dental.innerHTML = dentpercentage;
              if (this._dental_wrapper) {
                result.data["discountPercentageDentalInsurance"]
                  ? this._dental_wrapper.classList.remove("t-hidden")
                  : this._dental_wrapper.classList.add("t-hidden");
              }
            }
            if (fitzme || mainpercentage || addpercentage || dentpercentage) {
              this._shortinfo.classList.remove("t-hidden");
            } else {
              this._shortinfo.classList.add("t-hidden");
            }
          }
        }
        this._pres?.classList?.remove("t-hidden");
        this._description?.classList?.add("t-hidden");
        this._error.innerHTML = "";
        this._collSearch.classList.remove("-has-error");
        this._collSearch.classList.add("parsley-success");
      } else {
        this._pres?.classList?.add("t-hidden");
        this._description?.classList?.remove("t-hidden");
        this._error.innerHTML = `<ul class="parsley-errors-list filled" data-backend-error><li class="parsley-custom-error-message">${result.errorMessage}</li></ul>`;
        this._collSearch.classList.remove("parsley-success");
        this._collSearch.classList.add("-has-error");
      }
      this._collSearch.classList.remove("loading");
      this._searchBtn.disabled = false;
      this._searchInput.disabled = false;
    } catch (error) {
      this._collSearch.classList.remove("loading");
      this._error.innerHTML = `<ul class="parsley-errors-list filled" data-backend-error><li class="parsley-custom-error-message">${error.message || this._options.backendError
        }</li></ul>`;
      this._searchBtn.disabled = false;
      this._searchInput.disabled = false;
      this._collSearch.classList.remove("parsley-success");
      this._collSearch.classList.add("-has-error");
      return;
    }
  }

  async _callbackend(sessionForm) {
    try {
      this._saveBtn.classList.add("loading");
      this._saveBtn.disabled = true;
      let f = fetch(this._options.saveUrl, {
        method: "POST",
        body: JSON.stringify(sessionForm),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      let response = await f;
      return response;
    } catch (error) {
      this._saveBtn.classList.remove("loading");
      this._saveBtn.disabled = false;
      return;
    }
  }
}

export default CollectiveSearch;
